import axios from 'axios'
import hub from './event'

const apiCall = ({controller, method, data}) => new Promise((resolve, reject) => {
  var loc = {
    getparam: ''
  }

  if (data === undefined) {
    data = {}
  }

  if (data.ctx !== undefined) {
    if (data.ctx.currentPage && data.ctx.perPage) {
      var startRange = 0
      if (data.ctx.currentPage === 1) {
        startRange = 0
      }
      if (data.ctx.currentPage > 1) {
        startRange = ((data.ctx.currentPage - 1) * data.ctx.perPage)
      }

      loc.getparam += '&range=' + startRange + '-' + (startRange + data.ctx.perPage)
    }

    if (data.ctx.sortBy) {
      if (data.ctx.sortDesc) {
        loc.getparam += '&ord=-' + data.ctx.sortBy
      } else {
        loc.getparam += '&ord=+' + data.ctx.sortBy
      }
    }
    if (data.ctx.columns) {
      loc.getparam += '&columns=' + data.ctx.columns
    }
    if (data.ctx.filters) {
      loc.getparam += '&filters=' + data.ctx.filters
    }
    if (data.ctx.filter) {
      if (data.ctx.filter.split(':').length <= 1) {
        loc.getparam += '&filters=search:' + data.ctx.filter
      } else {
        loc.getparam += '&filters=' + data.ctx.filter
      }
    }
  }

  if (data.getparam) {
    loc.getparam += data.getparam
    delete data.getparam
  }

  if (method === 'GET') {
    var url = ''

    if (data.id !== undefined) {
      url = '/api/' + controller + '/' + data.id
    } else {
      url = '/api/' + controller
    }

    axios.get(url + '?' + loc.getparam, {
      params:
          {
            token: localStorage.getItem('user-token'),
            data: data.data
          }
    }).then(resp => {
      if (resp.data.status === 'Error' && resp.data.message.indexOf('Invalid token: ') === 0) {
        hub.$emit('gError', resp.data.message)
        reject(resp.data.message)
      } else {
        resolve(resp)
      }
    }).catch(error => {
      reject(error)
    })
  }

  if (method === 'POST') {
    axios.post('/api/' + controller + '?token=' + localStorage.getItem('user-token'), { data }
    ).then(resp => {
      if (resp.data.status === 'Error' && resp.data.message.indexOf('Invalid token: ') === 0) {
        hub.$emit('gError', resp.data.message)
        reject(resp.data.message)
      } else {
        resolve(resp)
      }
    }).catch(error => {
      reject(error)
    })
  }

  if (method === 'PUT') {
    axios.put('/api/' + controller + '/' + data.id + '?token=' + localStorage.getItem('user-token'), { data }
    ).then(resp => {
      if (resp.data.status === 'Error' && resp.data.message.indexOf('Invalid token: ') === 0) {
        hub.$emit('gError', resp.data.message)
        reject(resp.data.message)
      } else {
        resolve(resp)
      }
    }).catch(error => {
      reject(error)
    })
  }

  if (method === 'DELETE') {
    axios.delete('/api/' + controller + '/' + data.id + '?token=' + localStorage.getItem('user-token')
    ).then(resp => {
      if (resp.data.status === 'Error' && resp.data.message.indexOf('Invalid token: ') === 0) {
        hub.$emit('gError', resp.data.message)
        reject(resp.data.message)
      } else {
        resolve(resp)
      }
    }).catch(error => {
      reject(error)
    })
  }
})

export default apiCall



// WEBPACK FOOTER //
// ./src/utils/api.js